import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

export const getDetailCompanyFinancial = createAsyncThunk('/dashboard_detail_company_financial/content', async (id) => {
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/detailCompanyFinancialDash/${id}`, {})
    return response.data;
})

export const dashboardDetailCompanyFinancialSlice = createSlice({
    name: 'dashboard_detail_company_financial',
    initialState: {
        isLoading: false,
        dashboard_detail_company_financial: []
    },

    /*extraReducers: {
        [getDetailCompanyFinancial.pending]: state => {
            state.isLoading = true
        },
        [getDetailCompanyFinancial.fulfilled]: (state, action) => {
            state.dashboard_detail_company_financial = action.payload.data
            state.isLoading = false
        },
        [getDetailCompanyFinancial.rejected]: state => {
            state.isLoading = false
        },
    }*/
    extraReducers: (builder) => {
        builder
            .addCase(getDetailCompanyFinancial.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getDetailCompanyFinancial.fulfilled, (state, action) => {
                state.dashboard_detail_company_financial = action.payload.data;
                state.isLoading = false;
            })
            .addCase(getDetailCompanyFinancial.rejected, (state) => {
                state.isLoading = false;
            });
    },
})

export default dashboardDetailCompanyFinancialSlice.reducer